import DeviceSplit from '../../../../../components/common/DeviceSplit'
import LandingNav from '../../../../../components/landing/navigation/LandingNav'
import MobileLandingNav from '../../../../../components/landing/navigation/LandingNav/MobileLandingNav'
import SiliconValleyChallenge from '../../../../../components/student/challenge/siliconValley/SiliconValleyChallenge'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'

const Index = () => {
  const isMobile = useIsMobile()
  return (
    <>
      <DeviceSplit isMobile={isMobile} mobile={<MobileLandingNav />} desktop={<LandingNav />} />
      <SiliconValleyChallenge />
    </>
  )
}

export default Index
